export enum CountriesStrings {
  ITALY = 'Italia'
}
